const FormLabel = {
 baseStyle: {
  color: '#292B30',
  fontSize: '12px',
  fontWeight: 400,
 },
};

const Modal = {
 baseStyle: {
  dialog: {
   borderRadius: '12px',
  },
 },
};

const Table = {
 baseStyle: {
  Thead: {
   bg: '#EAEAEA',
   h: '51px',
  },
  th: {
   textTransform: 'none',
   letterSpacing: 'normal',
   fontWeight: 600,
  },
  td: {
   fontSize: '14px',
  },
 },
};

const Input = {
 variants: {
  filled: {
   field: {
    background: '#F5F5FB',
   },
  },
  viewMode: {
   field: {
    background: '#F5F5FB',
    border: '1px solid #F5F5FB',
    color: '#292B30', // Maintaining regular text color
    opacity: 1,
    cursor: 'default',
    _disabled: {
     // Override default disabled styles
     background: '#F5F5FB !important',
     opacity: 1,
     color: '#292B30',
     cursor: 'default',
     border: '1px solid #F5F5FB',
     // Ensuring the background stays consistent even with autofill
     WebkitBoxShadow: '0 0 0px 1000px #F5F5FB inset',
     WebkitTextFillColor: '#292B30',
    },
    _hover: {
     background: '#F5F5FB',
     border: '1px solid #F5F5FB',
    },
    _readOnly: {
     background: '#F5F5FB',
     border: '1px solid #F5F5FB',
    },
   },
  },
 },
};

// EG-41 — V5: correção na RAIZ da borda invisível.
//
// A paleta deste projeto não segue a convenção de escala do Chakra: gray.200
// vale #F5F8F6, quase branco. O Chakra usa justamente gray.200 como borda
// padrão de Checkbox e Select, então a caixa e o campo ficavam sem limite
// visível em fundo claro — em TODO o painel, não só nas telas da EG-41.
//
// A correção anterior era pontual, componente a componente. Esta troca o
// default, e prop inline continua vencendo: components/Input/Select.jsx, que
// já define border explicitamente, não é afetado.
//
// O que NÃO foi mexido aqui: os tokens da paleta. blue.100 é o azul forte de
// marca, usado de propósito em botões primários — renomeá-lo para liberar o
// tom 100 como tint é refatoração de outra ordem, e fica registrada como
// dívida.
const BORDA_DE_CAMPO = '#797D9A'; // gray.400 da paleta, contraste suficiente

const Checkbox = {
 baseStyle: {
  control: {
   borderWidth: '2px',
   borderColor: BORDA_DE_CAMPO,
   _hover: {
    borderColor: '#616488',
   },
  },
 },
 variants: {
  viewMode: {
   control: {
    _disabled: {
     bg: '#F5F5FB !important',
     borderColor: '#5C6066 !important',
    },
   },
  },
 },
};

// A borda do Select é resolvida na VARIANT `outline` do Chakra, não no
// baseStyle — e a outline usa `borderColor: inherit`, que herda a cor do texto.
// Sobrescrever o baseStyle não tinha efeito nenhum: o campo aparecia com borda
// escura por acidente, herdada do texto, e mais pesada que o resto do painel.
//
// A cor não é escolha nova: #B8CAE8 já é a convenção do projeto, definida em
// components/Input/Select.jsx. O Select cru passa a seguir o mesmo padrão do
// wrapper, que é o que uma correção de raiz deve fazer.
const BORDA_DE_SELECT = '#B8CAE8';

const Select = {
 variants: {
  outline: {
   field: {
    borderColor: BORDA_DE_SELECT,
    _hover: {
     borderColor: '#8FAFDD',
    },
   },
  },
 },
};

const components = {
 CustomBadge: {
  baseStyle: {
   borderRadius: '8px',
   fontSize: 'sm',
   display: 'flex',
   justifyContent: 'center',
   textAlign: 'center',
   p: '10px',
  },
  variants: {
   warning: {
    bg: '#FBDED5',
    color: '#EA582B',
   },
   error: {
    bg: '#EA582B',
    color: 'white',
   },
   success: {
    bg: '#78C151',
    color: 'white',
   },
   help: {
    fontWeight: 600,
    bg: 'rgba(0, 115, 187, 0.10)',
    color: '#0073BB',
    borderRadius: '20px',
   },
  },
  sizes: {
   sm: {
    p: '8.5px',
    fontSize: '13px',
    lineHeight: 'normal',
   },
   md: {
    px: '16px',
   },
   lg: {
    fontSize: '18px',
    borderRadius: '17px',
   },
  },
 },
 Button: {
  baseStyle: {
   fontWeight: '700',
   fontSize: 'md',
   borderRadius: '8px',
   _hover: {
    opacity: 0.7,
   },
  },
  sizes: {
   large: {
    w: '241px',
    h: '59px',
   },
   medium: {
    w: '280px',
    h: '49px',
    fontSize: '16px',
   },
   small: {
    w: '80px',
    h: '30px',
    fontSize: '13px',
   },
  },
  variants: {
   primary: {
    bg: '#0073BB',
    color: 'white',
    _disabled: {
     opacity: 1,
     color: 'gray.300',
     bg: '#E5E5E5',
     cursor: 'not-allowed',
    },
   },
   secondary: {
    bg: 'none',
    color: '#0073BB',
    border: '1px solid #0073BB',
    _disabled: {
     opacity: 1,
     color: 'rgba(41, 43, 48, 0.5)',
     bg: 'none',
     borderColor: 'rgba(41, 43, 48, 0.5)',
     cursor: 'not-allowed',
    },
   },
   tertiary: {
    bg: '#588F3D',
    color: 'white',
    _hover: {
     opacity: 0.7,
    },
   },
   orange: {
    bg: '#EA582B',
    color: 'white',
   },
   base: {
    bg: '#588F3D',
    color: 'white',
   },
   ghost: {
    fontWeight: 400,
    color: 'blue.100',
    fontSize: '14px',
    padding: 0,
    _hover: {
     bg: 'none',
     fontWeight: 500,
    },
   },
   cancel: {
    color: '#EA582B',
    borderWidth: '1px',
    border: '1px solid #EA582B',
   },
   'close-modal': {
    w: '100%',
    borderRadius: 0,
    bg: 'blue.100',
    color: 'white',
    boxShadow: '0px 5px 20px 0px rgba(230, 0, 0, 0.10)',
   },
   underline: {
    padding: '8px',
    h: '35px',
    backgroundColor: 'transparent',
    color: '#0073BB',
    lineHeight: '18.78px',
    fontWeight: 700,
    textDecoration: 'underline',
   },
  },
 },
 Heading: {
  sizes: {
   lg: {
    fontSize: '24px',
   },
  },
 },
 Accordion: {
  baseStyle: {
   root: { border: 'none', bg: 'transparent' },
   container: { border: 'none', bg: 'transparent' },
   icon: { w: '24px', h: '24px' },
  },
 },
 Tabs: {
  baseStyle: {
   tab: {
    whiteSpace: 'nowrap',
   },
  },
  variants: {
   primary: {
    tab: {
     color: '#5C6066',
     bg: 'white',
     p: '0 8px',
     height: '30px',
     alignItems: 'baseline',
     borderBottom: '1px solid #CCCFD1',
     _selected: {
      color: '#292B30',
      fontWeight: '600',
      borderBottom: '3px solid #0073BB',
     },
    },
    tablist: {
     gap: '16px',
     border: 'none',
    },
    tabpanel: {
     p: 0,
    },
   },
  },
 },
 FormLabel,
 Modal,
 Table,
 Input,
 Checkbox,
 Select,
};

export default components;
